<template>
  <el-dialog :title="!dataForm.id ? 'Add Commission' : 'Edit Commission'" :close-on-click-modal="false" :visible.sync="visible" width="800px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="150px">
      <el-form-item label="Name" prop="name">
        <el-input v-model="dataForm.name" clearable placeholder="Name"></el-input>
      </el-form-item>
      <el-form-item label="Commission Rate" prop="commissionRate">
        <el-input v-model="dataForm.commissionRate" placeholder="Commission Rate" class="wdb100" v-positivePoint>
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="Contact Info" prop="contact">
        <el-input v-model="dataForm.contact" type="textarea" :rows="5" :autosize="{ minRows: 4 }" resize="none" placeholder="Contact Info"></el-input>
      </el-form-item>
      <el-form-item label="Remark" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" :rows="5" :autosize="{ minRows: 4 }" resize="none" placeholder="Remark"></el-input>
      </el-form-item>
      <el-form-item label="Supplier" prop="supplierId">
        <el-select v-model="dataForm.supplierId" filterable clearable class="wdb100">
          <el-option v-for="item in supplierList" :key="`supplier-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Attachments" prop="attachmentUrls">
        <el-multiple-file-uploader v-model="dataForm.attachmentUrls"></el-multiple-file-uploader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">Submit</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { divide, multiply } from "@/utils/count";
import validatorMixin from "@/mixins/validatorMixin";
export default {
  mixins: [validatorMixin],
  props: {
    supplierList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        name: "",
        commissionRate: null,
        contact: "",
        remark: "",
        attachmentUrls: [],
        supplierId: null,
      },
      dataRule: {
        name: [{ required: true, message: "please enter", trigger: "submit" }],
        commissionRate: [
          { required: true, message: "please enter", trigger: "submit" },
          { validator: this.validateWithinZeroToHundred, trigger: "submit" },
        ],
        supplierId: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  methods: {
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        this.dataForm = {
          id: data.id,
          name: data.name,
          commissionRate: multiply(data.commissionRate, 100),
          contact: data.contact,
          remark: data.remark,
          attachmentUrls: data.attachmentUrls || [],
          supplierId: data.supplier?.id,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
          dataFormCopy.commissionRate = divide(dataFormCopy.commissionRate, 100);
          this.$http
            .post(this.dataForm.id ? `/admin/stCommission/${this.dataForm.id}/update` : `/admin/stCommission/create`, dataFormCopy)
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
